import { type ThemeConfig } from 'antd'
import { brandTokens } from './brand'

export const lightTheme: ThemeConfig = {
  hashed: false,
  cssVar: {
    prefix: '',
    key: 'app',
  },
  token: {
    fontFamily: '"Noto Sans", sans-serif',
    fontSizeIcon: 16, // 1rem
    borderRadius: 6, // 0.375rem

    colorBgLayout: '#FFFFFF',
    colorBgElevated: '#FFFFFF',
    colorBgContainer: '#FFFFFF',
    colorBgSpotlight: brandTokens.gray8,
    colorBgBlur: '#FFFFFF',
    colorBgMask: `${brandTokens.gray8}73`, // 45% opacity
    colorBgSolid: brandTokens.gray6,
    colorBgSolidHover: brandTokens.gray7,
    colorBgSolidActive: brandTokens.gray9,

    colorSplit: brandTokens.gray2,

    colorBorder: brandTokens.gray3,
    colorBorderSecondary: brandTokens.gray3,

    colorText: brandTokens.gray9,
    colorTextSecondary: brandTokens.gray8,
    colorTextTertiary: brandTokens.gray7,
    colorTextQuaternary: brandTokens.gray3,

    colorFill: brandTokens.gray1,
    colorFillSecondary: brandTokens.gray2,
    colorFillTertiary: brandTokens.gray1,
    colorFillQuaternary: brandTokens.gray1,

    colorLink: brandTokens.tomato5,
    colorLinkHover: brandTokens.tomato4,
    colorLinkActive: brandTokens.tomato5,

    colorPrimary: brandTokens.tomato5,
    colorPrimaryHover: brandTokens.tomato4,
    colorPrimaryActive: brandTokens.tomato7,
    colorPrimaryBg: brandTokens.tomato0,
    colorPrimaryBgHover: brandTokens.tomato1,
    colorPrimaryBorder: brandTokens.tomato2,
    colorPrimaryBorderHover: brandTokens.tomato3,
    colorPrimaryText: brandTokens.tomato5,
    colorPrimaryTextHover: brandTokens.tomato4,
    colorPrimaryTextActive: brandTokens.tomato7,

    colorInfo: brandTokens.blue6,
    colorInfoHover: brandTokens.blue5,
    colorInfoActive: brandTokens.blue8,
    colorInfoBg: brandTokens.blue1,
    colorInfoBgHover: brandTokens.blue2,
    colorInfoBorder: brandTokens.blue3,
    colorInfoBorderHover: brandTokens.blue4,
    colorInfoText: brandTokens.blue6,
    colorInfoTextHover: brandTokens.blue7,
    colorInfoTextActive: brandTokens.blue8,

    colorSuccess: brandTokens.green6,
    colorSuccessHover: brandTokens.green5,
    colorSuccessActive: brandTokens.green8,
    colorSuccessBg: brandTokens.green1,
    colorSuccessBgHover: brandTokens.green2,
    colorSuccessBorder: brandTokens.green3,
    colorSuccessBorderHover: brandTokens.green4,
    colorSuccessText: brandTokens.green6,
    colorSuccessTextHover: brandTokens.green7,
    colorSuccessTextActive: brandTokens.green8,

    colorWarning: brandTokens.yellow6,
    colorWarningHover: brandTokens.yellow5,
    colorWarningActive: brandTokens.yellow8,
    colorWarningBg: brandTokens.yellow1,
    colorWarningBgHover: brandTokens.yellow2,
    colorWarningBorder: brandTokens.yellow3,
    colorWarningBorderHover: brandTokens.yellow4,
    colorWarningText: brandTokens.yellow6,
    colorWarningTextHover: brandTokens.yellow7,
    colorWarningTextActive: brandTokens.yellow8,

    colorError: brandTokens.red6,
    colorErrorHover: brandTokens.red5,
    colorErrorActive: brandTokens.red8,
    colorErrorBg: brandTokens.red1,
    colorErrorBgHover: brandTokens.red2,
    colorErrorBgActive: brandTokens.red3,
    colorErrorBgFilledHover: brandTokens.red2,
    colorErrorBorder: brandTokens.red3,
    colorErrorBorderHover: brandTokens.red4,
    colorErrorText: brandTokens.red6,
    colorErrorTextHover: brandTokens.red7,
    colorErrorTextActive: brandTokens.red8,

    ...brandTokens,

    // TODO: remove after update to antd v6 (antd v5 is 1 to 10, antd v6 is 0 to 9)
    blue: brandTokens.blue7,
    'blue-1': brandTokens.blue0,
    'blue-2': brandTokens.blue1,
    'blue-3': brandTokens.blue2,
    'blue-4': brandTokens.blue3,
    'blue-5': brandTokens.blue4,
    'blue-6': brandTokens.blue5,
    'blue-7': brandTokens.blue6,
    'blue-8': brandTokens.blue7,
    'blue-9': brandTokens.blue8,
    'blue-10': brandTokens.blue9,

    cyan: brandTokens.vistaBlue3,
    'cyan-1': brandTokens.vistaBlue0,
    'cyan-2': brandTokens.vistaBlue1,
    'cyan-3': brandTokens.vistaBlue2,
    'cyan-4': brandTokens.vistaBlue3,
    'cyan-5': brandTokens.vistaBlue4,
    'cyan-6': brandTokens.vistaBlue5,
    'cyan-7': brandTokens.vistaBlue6,
    'cyan-8': brandTokens.vistaBlue7,
    'cyan-9': brandTokens.vistaBlue8,
    'cyan-10': brandTokens.vistaBlue9,

    geekblue: brandTokens.tekhelet5,
    'geekblue-1': brandTokens.tekhelet0,
    'geekblue-2': brandTokens.tekhelet1,
    'geekblue-3': brandTokens.tekhelet2,
    'geekblue-4': brandTokens.tekhelet3,
    'geekblue-5': brandTokens.tekhelet4,
    'geekblue-6': brandTokens.tekhelet5,
    'geekblue-7': brandTokens.tekhelet6,
    'geekblue-8': brandTokens.tekhelet7,
    'geekblue-9': brandTokens.tekhelet8,
    'geekblue-10': brandTokens.tekhelet9,

    green: brandTokens.green6,
    'green-1': brandTokens.green0,
    'green-2': brandTokens.green1,
    'green-3': brandTokens.green2,
    'green-4': brandTokens.green3,
    'green-5': brandTokens.green4,
    'green-6': brandTokens.green5,
    'green-7': brandTokens.green6,
    'green-8': brandTokens.green7,
    'green-9': brandTokens.green8,
    'green-10': brandTokens.green9,

    purple: brandTokens.royalPurple6,
    'purple-1': brandTokens.royalPurple0,
    'purple-2': brandTokens.royalPurple1,
    'purple-3': brandTokens.royalPurple2,
    'purple-4': brandTokens.royalPurple3,
    'purple-5': brandTokens.royalPurple4,
    'purple-6': brandTokens.royalPurple5,
    'purple-7': brandTokens.royalPurple6,
    'purple-8': brandTokens.royalPurple7,
    'purple-9': brandTokens.royalPurple8,
    'purple-10': brandTokens.royalPurple9,

    red: brandTokens.red5,
    'red-1': brandTokens.red0,
    'red-2': brandTokens.red1,
    'red-3': brandTokens.red2,
    'red-4': brandTokens.red3,
    'red-5': brandTokens.red4,
    'red-6': brandTokens.red5,
    'red-7': brandTokens.red6,
    'red-8': brandTokens.red7,
    'red-9': brandTokens.red8,
    'red-10': brandTokens.red9,

    yellow: brandTokens.yellow5,
    'yellow-1': brandTokens.yellow0,
    'yellow-2': brandTokens.yellow1,
    'yellow-3': brandTokens.yellow2,
    'yellow-4': brandTokens.yellow3,
    'yellow-5': brandTokens.yellow4,
    'yellow-6': brandTokens.yellow5,
    'yellow-7': brandTokens.yellow6,
    'yellow-8': brandTokens.yellow7,
    'yellow-9': brandTokens.yellow8,
    'yellow-10': brandTokens.yellow9,
  },
  components: {
    Layout: {
      headerBg: '#FFFFFF',
    },
    Rate: {
      starColor: brandTokens.yellow5, // https://github.com/ant-design/ant-design/blob/5.x-stable/components/rate/style/index.ts#L133
    },
    Table: {
      rowHoverBg: brandTokens.gray0,
      rowExpandedBg: brandTokens.gray0,
      bodySortBg: brandTokens.gray0,
    },
    Menu: {
      itemHoverBg: brandTokens.gray1,
    },
  },
}
